var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.haveIcon)?_c(_vm.icon,_vm._g(_vm._b({tag:"component"},'component',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }